<template>
  <div id="indexComponent">
    <Header 
      :setShow="['timeZone', 'order', 'oddsType', 'oddsForm']" 
      :tsz="svrTimestamp" 
      :isLogin="loginShow" 
      :myLeague="myLeague" 
      :navTab="0" 
      @onLeagueFollowChange="onLeagueFollowChange"  
      @onChangeSetting="onChangeSetting" 
      @onChangLogin="onChangLogin" 
    />
    <Banner 
      :homeSate="homeSate" 
      :loginInfoShow="loginInfoShow"
      @onChangLogin="onChangLogin" 
    />
    <hotPrediction 
      :listHotData="listHotData" 
      :setting="setting" 
    />
    <Prediction  
      :listDataPro="listDataPro" 
      :setting="setting" 
      :myLeague="myLeague" 
      :svrTimestamp="svrTimestamp" 
      :loginInfoShow="loginInfoShow"
      @dateSelected="dateSelected" 
      @onChangLogin="onChangLogin"
    />
    <Rank 
      :rankData="rankData" 
      :myLeague="myLeague" 
      @onLeagueFollowChange="onLeagueFollowChange" 
    />
    <Footer />
  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  import { getListHot, getSocket, getSocketUpdate, getPredictionRank, getListHome, getHomeStat } from '@/api/api';

  import Header from '@/components/header.vue';
  import Footer from '@/components/footer.vue';
  import Banner from './components/banner.vue';
  import hotPrediction from './components/hotPrediction.vue';
  import Rank from './components/rank.vue';
  import Prediction from './components/homePredictionMatch.vue';
  
	export default {
    name: 'index',
    components: {
      Header,
      Footer,
      Banner,
      hotPrediction,
      Rank,
      Prediction,
    },
    
    props: {},

		data(){
			return{
        setting: {
          oddsForm: 1,
          tsz: '+08:00'
        },
        svrTimestamp: 0, // 系统时间
        version: 0, // 数据版本号
        liveSate: [1,2,3,5,10,11,16], //比赛进行中

        liveParam: { // 比赛预测列表请求参数
          timeZone: '+08:00',
          userToken: '',
          langNumber: 3,
          platform: 4,
          portType: 1,
          date: '',
          userId: ''
        },

        homeSate: {}, //首页预测模型统计
        listHotData: [], // 热门预测数据
        rankData: {}, // 排行榜数据

        listPageNum: {
          current: 0,
          page: 10, // 每页10场
          total: 0
        },
        listData: {}, // 比赛预测列表源数据
        listDataPro: {

        }, // 比赛预测列表传参数据

        myLeague:{}, // 我的关注

        isLoginTips: false,
        loginShow: false, // 是否显示登录弹窗
        loginInfoShow: false, // 是否已登录
      }
		},

    computed: {
      ...mapState('home', ['SEO']),
    },

    mounted(){
      
    },

		methods:{
      // 登录弹窗回调
      onChangLogin(val){
        let _val = val;
        this.loginShow = _val.loginShow;
        this.loginInfoShow = _val.loginInfoShow;
      },
      // 登录底部提示弹框
      loginTips() {
        let _cookie = this.common.getCookie('logintips');
				
				if((typeof(_cookie) != 'undefined' && _cookie != null) || this.loginInfoShow){
          this.isLoginTips = false;
				}else{
          this.isLoginTips = true;
        }
      },
      // 关闭登录底部提示弹框
      loginTipsClose() {
        this.isLoginTips = false;
        this.common.setCookie('logintips', true, 1);
      },

      // 预测列表日期组件回调
      dateSelected(val){
        let _date = val;
        if(this.liveParam['date'] == _date){
          return;
        }
        this.liveParam['date'] = _date;
        this.listDataPro = {};
        this.getListHome(this.liveParam, 'live');
      },

      // 关注赛事变化回调
      onLeagueFollowChange(val){
        if(val){
          this.myLeague = val;
        }
      },

      // 设置回调参数操作
      onChangeSetting(e){
        console.log('设置回调参数操作', e)
        let _setting = e;
        
        let _oddsForm = this.common.jsonParse(this.setting.oddsForm)*1;
        let _tsz = this.common.jsonParse(this.liveParam)['timeZone'];


        if(_oddsForm != _setting.oddsFormRadio*1){ //赔率格式
          this.setting.oddsForm = _setting.oddsFormRadio*1;
          return;
        }

        if(_tsz != _setting.tsz){ //时区
          this.setting['tsz'] = this.liveParam['timeZone'] = _setting.tsz;
          this.getListHome(this.liveParam, 'live');
          this.getHomeStat();
        }
      },

      // 比赛预测列表数据整理
      listPredCollation(){
        let _data = this.common.jsonParse(this.listData), _matchList = _data['predList'], _matchData = {}, _listPageNum = this.listPageNum;

        // 比赛数据包整理
        if(typeof(_matchList) != 'undefined'){
          _matchList.forEach((item, index) => {
            _matchData[item['match'].matchId] = item;
          });
        }
        // for(let i=_listPageNum['current']; i<_listPageNum.page; i++){
        //   _matchData[_matchList[i]['match'].matchId] = _matchList[i];
        // }

        _data['predList'] = _matchData;

        this.listDataPro = _data;
      },

      // 列表更新
      listUpdate(data){
        console.log("比分更新数据", data)
        let _data = JSON.parse(JSON.stringify(getSocketUpdate(data, 'FootballListUpdate')));
        let _version = _data['version'];
        this.version = _version;
        console.log("比分解析后：", JSON.stringify(_data))

        // 更新比赛
        let _state = this.liveSate;
        let _predList = JSON.parse(JSON.stringify(this.listDataPro['predList']));
        let _updateMatch = _data['updateMatch'];
        let _newPredList = {..._predList};

        if(typeof(_updateMatch) != 'undefined' && _updateMatch.length > 0){

          _updateMatch.forEach((item, index) => {
            if(_state.includes(item.state)){
              if(typeof(item.homeLive.scoreFull) == 'undefined'){
                item.homeLive.scoreFull = 0;
              }

              if(typeof(item.awayLive.scoreFull) == 'undefined'){
                item.awayLive.scoreFull = 0;
              }
            }
            
            // if(typeof(_predList[item.matchId]) != 'undefined'){
            //   _newPredList[item.matchId] = {
            //     oldHomeLive: _predList[item.matchId]['homeLive'] || 0,
            //     oldAwayLive: _predList[item.matchId]['awayLive'] || 0,
            //     homeLive: item.homeLive,
            //     awayLive: item.awayLive,
            //     state: item.state
            //   };
            // }
            // if(typeof(_newPredList[item.matchId]) == 'undefined'){
            //   _newPredList[item.matchId] = {};
            // }
            // _newPredList[item.matchId]['match'] = item;
            if(typeof(_newPredList[item.matchId]) != 'undefined'){
              _newPredList[item.matchId]['match']['homeLive']['scoreFull'] = item.homeLive.scoreFull;
              _newPredList[item.matchId]['match']['awayLive']['scoreFull'] = item.awayLive.scoreFull;
              _newPredList[item.matchId]['match']['state'] = item.state;
            }
          })

          //let _newMatchData = this.common.mergeObjects(_predList, _newPredList);

          this.listDataPro['predList'] = _newPredList;

          console.log("比分更新后：", JSON.stringify(this.listDataPro['predList']))
        }
      },

      // 指数更新
      oddsUpdate(data){
        console.log("指数更新数据", data)
        let _data = this.common.jsonParse(getSocketUpdate(data, 'FootballListLuckUpdate'));
        let _version = _data['version'];
        this.version = _version;
        console.log("指数解析后：", JSON.stringify(_data))

        // 更新指数
        let _predList = JSON.parse(JSON.stringify(this.listDataPro['predList']));
        let _newPredList = {..._predList};
        for(let key in _data ){ // 更新类型
          if(Object.keys(_data[key]).length > 0){
            let _item = _data[key];
            for(let matchId in _item){
              let _ol = _item[matchId];
              
              if(typeof(_newPredList[matchId]) != 'undefined'){
                if(key == 'asianLuckMatch'){
                  _newPredList[matchId]['asianPrev'] = _predList[matchId]['asian'] || '';
                  _newPredList[matchId]['asian'] = _ol;
                }

                if(key == 'threeWayLuckMatch'){
                  _newPredList[matchId]['threeWayPrev'] = _predList[matchId]['threeWay'] || '';
                  _newPredList[matchId]['threeWay'] = _ol;
                }

                if(key == 'totalLuckMatch'){
                  _newPredList[matchId]['totalPrev'] = _predList[matchId]['total'] || '';
                  _newPredList[matchId]['total'] = _ol;
                }
              }

            }
          }
        }

        //let _newOddsData = this.common.mergeObjects(_predList, _newPredList);
        this.listDataPro['predList'] = _newPredList;

      },

      // 获取关注联赛
      async getFavLeagues(){
        let _myLeague = this.common.getStorage('leagueListFollow');
        //console.log('获取关注联赛', _myLeague)
        if(_myLeague != null){
          this.myLeague = JSON.parse(_myLeague);
        }
      },

      // 首页预测模型统计
      async getHomeStat() {
          let param = {
            timeZone: this.setting.tsz
          };

          await getHomeStat(param).then((res) => {
            this.homeSate = this.common.jsonParse(res.data) || {};
            console.log('首页预测模型统计', this.homeSate)
          }).catch((res) => {
            console.error(res)
          })

      },

      // 获取热门预测数据
      async getListHot() {
          let param = {};
          
          let _userInfo = this.common.getCookie('userInfo');
				
          if(typeof(_userInfo) != 'undefined' && _userInfo != null){
            _userInfo = JSON.parse(_userInfo);
            param.userToken = _userInfo.token;
          }

          await getListHot(param).then((res) => {
            this.listHotData = this.common.jsonParse(res.data.predList) || [];
            console.log('获取热门预测数据', this.listHotData)
          }).catch((res) => {
            console.error(res)
          })

      },
      // 获取排行榜数据
      async getPredictionRank() {
          let param = {};
          
          let _userInfo = this.common.getCookie('userInfo');
				
          if(typeof(_userInfo) != 'undefined' && _userInfo != null){
            _userInfo = JSON.parse(_userInfo);
            param.userToken = _userInfo.token;
          }

          await getPredictionRank(param).then((res) => { //排行榜
            this.rankData = this.common.jsonParse(res.data);
          }).catch((res) => {
            console.error(res)
          })

      },

      // 获取比赛预测列表
      async getListHome(obj, liveType) {
        let param = Object.assign(this.liveParam, obj);
          
        let _userInfo = this.common.getCookie('userInfo');
      
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }

        let _setting = this.common.getCookie('setting');

        if(typeof(_setting) != 'undefined' && _setting != null){
          //alert('设置信息')
          //console.log('设置信息',(JSON.stringify(_setting)));
          _setting = JSON.parse(_setting);
          this.setting.oddsForm = _setting.oddsFormRadio*1;
          this.setting.tsz = this.liveParam['timeZone'] = param.timeZone = _setting.tsz;
          
        }

        await getListHome(param).then((res) => {
          this.listData = this.common.jsonParse(res.data);
          //this.version = res.data.version;
          this.svrTimestamp = res.serverTimestamp;
          this.listPredCollation();
        }).catch((res) => {
          console.error(res)
        })

        if(typeof(liveType) != 'undefined'){ //单比分请求
          return;
        }

        let _socketParam = {
          type: 101,
          scoreVersion: Number(this.version)
        };
        await getSocket(this, _socketParam); // 开启socket比分更新请求
        await this.$socket.registerCallBack('FootballListReconnect', async ()=>{
          await this.getListHome(this.liveParam, 'live');
          await getSocket(this, _socketParam);
        });
        await this.$socket.registerCallBack('FootballListUpdate', this.listUpdate);
        await this.$socket.registerCallBack('FootballListLuckUpdate', this.oddsUpdate);

      },

      // 初始化
      async init(){
        let eventName = 'LS_PC_Home';
        if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_Home';
        }
        this.common.googleEvent(eventName);
        
        await this.common.isLogin().then((res)=>{
          let _isLogin = res;

          if(_isLogin){// 已登录
            this.loginInfoShow = true;
          }else{ // 未登录
            this.common.delCookie('userInfo');
            this.loginInfoShow = false;
          }
        });
        await this.loginTips();

        await this.getListHome({date: ''});
      }

		},

		created(){
      this.getFavLeagues();
      this.getHomeStat();
      this.getListHot();
      this.getPredictionRank();
      this.init();
		},

    beforeDestroy() {
      
    },

    destroyed() {
      // 在组件销毁前关闭WebSocket连接
      this.$socket.unRegisterCallBack('FootballListReconnect');
      this.$socket.unRegisterCallBack('FootballListUpdate');
      this.$socket.unRegisterCallBack('FootballListLuckUpdate');
    },
	};

</script>
<style lang="less" scoped>
@import '~@/style/index/index.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/index.vue